module.exports = __webpack_public_path__ + "img/hipercard.cf6062b9.png";